<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t("menu.google") }}
        </div>
      </div>
      <div class="area-description" v-html="pageDescription"></div>
      <!-- Area cards -->
      <div class="results-cards">
        <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-if="loading"></b-spinner></div>
        <b-card
            class="results-card"
            no-body
            border-variant="white"
            v-for="(location, index) in filteredLocations"
            :key="location.id"
        >
          <div @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
            <b-link :href="location.link" target="_blank" style="text-decoration: none;color: #2c3e50;width: 100%">
              <b-card-img-lazy class="results-card-image" :class="{'selected': isCardSelected(index)}" :src="location.preview" :alt="location.titolo" top></b-card-img-lazy>
            </b-link>
          </div>
          <b-link :href="location.link" target="_blank" style="text-decoration: none;color: #2c3e50" @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
            <b-card-text class="results-card-title" style="margin: 5px 5px 0 15px;">
              {{ location.titolo }}
            </b-card-text>
          </b-link>
          <b-link :href="location.link" target="_blank" style="text-decoration: none;color: #2c3e50" @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
            <b-card-text class="results-card-subtitle" style="margin-left: 15px;" :class="{'selected': isCardSelected(index)}">
              {{ location.struttura }}
            </b-card-text>
          </b-link>
        </b-card>
        <div style="display: block">
          <div class="area-top-title">
            {{ $t("stories") }}
          </div>
          <div id="stories">
            <iframe allowfullscreen allow="autoplay" frameborder="0" width="800" height="600" style="margin: 10px; max-width:100%;" src="https://embed.culturalspot.org/embedv2/story/BgURTlpJR5z-Fg" referrerpolicy="strict-origin-when-cross-origin"></iframe>
            <iframe allowfullscreen allow="autoplay" frameborder="0" width="800" height="600" style="margin: 10px; max-width:100%;" src="https://embed.culturalspot.org/embedv2/story/fgWhOqjZvzIvwg" referrerpolicy="strict-origin-when-cross-origin"></iframe>
            <iframe allowfullscreen allow="autoplay" frameborder="0" width="800" height="600" style="margin: 10px; max-width:100%;" src="https://embed.culturalspot.org/embedv2/story/4wXhVW21Nv5-zQ" referrerpolicy="strict-origin-when-cross-origin"></iframe>
            <iframe allowfullscreen allow="autoplay" frameborder="0" width="800" height="600" style="margin: 10px; max-width:100%;" src="https://embed.culturalspot.org/embedv2/story/YgVBUZGUoLCmog" referrerpolicy="strict-origin-when-cross-origin"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoogleArts',
  data: function() {
    return {
      pageDescriptionRecord: "",
      locations: [],
      loading: true,
    };
  },
  created() {
    this.fetchContent()
  },
  computed: {
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
        }
      return desc;
    },
    filteredLocations() {
      const locations = this.locations;
      for (let location in locations) {
        // Compila titolo
        locations[location].titolo = this.$utilities.getTranslation(locations[location], "titolo", this.$i18n.locale);
        locations[location].struttura = this.$utilities.getTranslation(locations[location], "struttura", this.$i18n.locale);
      }

      let result = locations;
      // Sort
      return result.sort((a, b) => {
        return a.ordine - b.ordine;
      })
    },
  },
  methods: {
    async fetchContent() {
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'google_arts'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];

      // Recupera i luoghi Street View
      const locationsData = await this.$client.getItems("streetview", {fields: ["*", "traduzioni.*"]});
      let locations = locationsData.data;
      let listOfIdDirectusFiles = "";
      for (let location in locations) {
        const defaultImageUrl = await this.$client.getAssetUrl("cl4ladr0lo8w4ck0", {key: "directus-large-contain"});
        if (locations[location].preview != null) {
          listOfIdDirectusFiles += locations[location].preview.id + ",";
        } else {
          locations[location].preview = defaultImageUrl;
        }
      }

      const filesData = await this.$client.getFiles({limit: -1, filter: {
          id: {
            in: listOfIdDirectusFiles
          }}});
      let files = filesData.data;
      for (let location in locations) {
        for (let file in files) {
          const imageId = "" + locations[location].preview.id;
          if (files[file].id == imageId) {
            const assetUrl = await this.$client.getAssetUrl(files[file].private_hash, {key: "directus-large-contain"});
            locations[location].preview = assetUrl;
          }
        }
      }
      this.locations = locations.sort((a,b) => (a.titolo > b.titolo) ? 1 : ((b.titolo > a.titolo) ? -1 : 0));
      this.loading = false;
    },
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex
    },
    isCardSelected (cardIndex) {
      return this.selectedCard === cardIndex
    },
  }
}
</script>

<style>
</style>
